query getFootballHistory($market_id: String) {
    getFootballHistory(market_id: $market_id)
}
